import { cn } from "@/lib/utils";
import { Loader2, type LucideProps } from "lucide-react";

type Props = LucideProps & {
  className?: string;
  title?: string;
};

export const LoadingMd = ({
  className,
  title = "ローディング中",
  ...props
}: Props) => {
  return (
    <>
      <Loader2 className={cn("h-8 w-8 animate-spin", className)} {...props} />
      <p>{title}</p>
    </>
  );
};

export const LoadingSm = ({
  className,
  title = "ローディング中",
  ...props
}: Props) => {
  return (
    <>
      <Loader2 className={cn("h-4 w-4 animate-spin", className)} {...props} />
      <p>{title}</p>
    </>
  );
};
